module.exports = __webpack_public_path__ + "img/generate-icon.881b101a.svg";